// Hook partagé Commercial : fetch /api/metier/hub-grids/pipeline-conversion
// avec auth Bearer + cookie + X-Tenant-ID dynamique.
import { useEffect, useState } from "react";

const API = process.env.REACT_APP_BACKEND_URL;

function getTenant() {
  try {
    const u = JSON.parse(localStorage.getItem("user") || "null");
    return u?.tenant_id || u?.tenant?.slug || "tef";
  } catch { return "tef"; }
}

export function useCommercialFetch(url = "/api/metier/hub-grids/pipeline-conversion", deps = []) {
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  // eslint-disable-next-line react-hooks/exhaustive-deps
  useEffect(() => {
    let cancelled = false;
    setLoading(true);
    setError(null);
    const token = localStorage.getItem("session_token");
    const headers = {
      "X-Tenant-ID": getTenant(),
      ...(token ? { Authorization: `Bearer ${token}` } : {}),
    };
    fetch(`${API}${url}`, { headers, credentials: "include" })
      .then((r) => (r.ok ? r.json() : Promise.reject(`HTTP ${r.status}`)))
      .then((d) => { if (!cancelled) setData(d); })
      .catch((e) => { if (!cancelled) setError(String(e.message || e)); })
      .finally(() => { if (!cancelled) setLoading(false); });
    return () => { cancelled = true; };
  }, deps);

  return { data, loading, error };
}

export const FUNNEL_COLORS = [
  "var(--oh-stat-blue-text)", "#6366F1", "#8B5CF6",
  "var(--oh-stat-purple-text)", "#10B981", "var(--oh-stat-green-text)",
];
